const SERVICE_URL = '/components/cldr-data/main';

export const loadLanguageName = (locale) => {
  const url = `${SERVICE_URL}/${locale}/languages.json`;
  return fetch(url).then(res => res.json());
};

export const loadTerritoryNames = (locale) => {
  const url = `${SERVICE_URL}/${locale}/territories.json`;
  return fetch(url).then(res => res.json());
};
